/**
 * Colours for comparing several servers on one chart: a fixed, colour-blind-safe order
 * (--series-1..6 in styles/index.css). Assign by a stable sort (e.g. client id), never by
 * filtered position, so toggling which servers are visible never repaints the survivors.
 */
const SERIES_COLORS = [
  'var(--series-1)',
  'var(--series-2)',
  'var(--series-3)',
  'var(--series-4)',
  'var(--series-5)',
  'var(--series-6)',
] as const;

export function seriesColor(index: number): string {
  return SERIES_COLORS[index % SERIES_COLORS.length]!;
}
